/*
|--------------------------------------------------------------------------
| Utilities: Accordion
|--------------------------------------------------------------------------
*/
/**
 * Accordion functionality
 * @namespce
 */
__gh__webApp.utilities.accordion = {

	/*
	 * Initialize all accordions
	 */
	 "init": function(){
		 this.loadAllAccordions();
	 },


	/*
	 * Load all accordions on a page
	 */
	"loadAllAccordions": function(options){
		var ghAccordion = this;

		$("[data-gh-accordion-loaded=false]").each(function(){
			var $accordion  = $(this),
			  	options		= {
				  "toggleDOM": $accordion.data('gh-accordion-toggle-dom'),
				  "panelDOM" : $accordion.data('gh-accordion-panel-dom'),
				};

			//Set loaded to true so it's not called again.
			$accordion.attr("data-gh-accordion-loaded",true);
			ghAccordion.bindEvents(options);
		});
	},


	/*
	 *
	 * @param {object} options
	 * @param {string} options.toggleDOM - DOM that contains the elements that will be clicked to toggle the open and close a panel
	 * @param {string} options.panelDOM -
	 */
	 "bindEvents": function(options){
		var toggleDOM 	= (options.toggleDOM) 	? options.toggleDOM : null,
		    panelDOM 	= (options.panelDOM) 	? options.panelDOM : null;

		var $allPanels = $(panelDOM).hide();

		$(document).on("click",toggleDOM,(function(e) {
			if($(e.target).is('.nav-category')) return true;
			$allPanels.not(this).slideUp();
			if (!$(this).next(panelDOM).is(':visible')){
				$(this).next(panelDOM).slideDown();
			}
			return false;
		}));
	}

};
